module.exports = __webpack_public_path__ + "img/penta-re-logo.bc9123f7.svg";